import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const qc = useQueryClient();
  const nav = useNavigate();
  const m = useMutation({
    mutationFn: () => api.post<{ ok: true }>('/login', { password }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me'] });
      nav('/');
    },
    onError: (e: Error) => setError(e.message || 'login failed'),
  });
  return (
    <div className="min-h-full grid place-items-center p-6">
      <form
        className="card w-full max-w-sm flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          setError(null);
          m.mutate();
        }}
      >
        <h1 className="text-lg font-semibold">Sign in</h1>
        <label className="text-sm flex flex-col gap-1">
          <span>Admin password</span>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </label>
        {error && <div className="text-danger text-sm">{error}</div>}
        <button className="btn btn-primary" type="submit" disabled={m.isPending}>
          {m.isPending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
